/**
 * Page was not loaded from a reload, history traversal (back/forward) or prefetch.
 * see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming/type
 */
export const pageFromNavigation = () => {
    if (window.performance.getEntriesByType) {
        return currentNavigationEventType() === 'navigate';
    }

    // Deprecated but needs to be used as the IOS 15.2 and less do not support the latest api
    // Navigation type for navigating is 0
    // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigation
    return performance.navigation.type === 0;
};

const currentNavigationEventType = () => currentNavigationEvent().type;
const currentNavigationEvent = () => navigationRecords()[0] || {};
const navigationRecords = () => performance.getEntriesByType('navigation');
